import React, {Component} from 'react';

import Page from '../common/Page';
import SideBar from '../common/SideBar';
import Pinboard from '../common/Pinboard';
import SubmitFeedback from '../common/SubmitFeedback';
import LoadingSpinner from '../common/LoadingSpinner';
import HowItWorks from '../overlay/HowItWorks';
import {ToastContainer} from 'react-toastify';

class MainWrapper extends Component {
  render() {
    return (
      <div className="x-container main-wrapper">
        <ToastContainer />
        <SideBar />

        <div className="main-container">
          <div className="x-row main-row">
            <Page children={this.props.children} />
            <Pinboard />
            <HowItWorks />
            <SubmitFeedback />
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }
}

export default MainWrapper;
